import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import PageNotFound from '../../common/PageNotFound/PageNotFound';
import Button from '../../components/Button/Button';
import { Variant } from '../../components/Button/Button.types';
import { ButtonsWrapper, Container, H2 } from './Error.styles';
import { ErrorProps } from './Error.types';

const Error: FC<ErrorProps> = ({ code }) => {
  const navigate = useNavigate();

  switch (code) {
    case 404:
    default:
      return (
        <Container>
          <PageNotFound />
          <H2>Page Not Found</H2>
          <ButtonsWrapper>
            <Button label='Go Back' variant={Variant.Secondary} onClick={() => navigate(-1)} />
            <Button label='All Tables' onClick={() => navigate('/tables')} />
          </ButtonsWrapper>
        </Container>
      );
  }
};

export default Error;
